import Glide from '@glidejs/glide';

export const B__BannerFeaturedProducts = () => ({
    init: () => {
        new Glide('.b--banner-featured-products .glide').mount();
    }
});
